
import state from './zviz2/zviz/state';
import {LifeCycle} from './zviz2/zviz/cycle';

export let formatNumber = function(value, shorten=false, fixedDecimal=false){

    value = parseFloat(value);
    if(isNaN(value)){
        return '-';
    }

    if(shorten && value >= 1000000000){
        if(fixedDecimal !== false){
            return (value/1000000000).toFixed(fixedDecimal) + ' bln';
        }
        return Math.round(value/10000000)/100 + ' bln';
    }else if(shorten && value >= 1000000){
        if(fixedDecimal !== false){
            return (value/1000000).toFixed(fixedDecimal) + ' mln';
        }
        return Math.round(value/10000)/100 + ' mln';
    }

    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");

}

export let formatDate = function(value, compact=true){
    let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 
            'August', 'September', 'October', 'November', 'December'];
    // transform format dd/mm/yyyy to yyyy-mm-dd
    
    let monthAbr = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    // for(let i = 0; i < monthAbr.length; i++){
    //     value = value.replace(monthAbr[i], ('0' +(i+1)).substring(0,2));
    // }

    let p = [];
    if(value.indexOf(' ') != -1){
        value = value.substring(0, value.indexOf(' '));
    }
    if(value.indexOf('/') != -1){
        p = value.split('/');
    }else if(value.indexOf('-') != -1){
        p = value.split('-');
    }
    if(p.length == 3){
        if(p[0].length != 4 || (p[0].length != 4 && p[2].length != 4)){   // dd-mm-yy format instead of yyyy-mm-dd, other option is dd-mon-yy
            if(monthAbr.indexOf(p[1].toUpperCase()) != -1){
                p[1] = ('0' + (monthAbr.indexOf(p[1].toUpperCase())+1)).slice(-2);
            }else{
                p[1] = ('0' + parseInt(p[1], 10)).slice(-2);
            }
            p[0] = ('0' + parseInt(p[0], 10)).slice(-2);
            p[2] = ('20' + p[2]).slice(-4);
            value = p[2] + '-' + p[1] + '-' + p[0];
        }
    }

    let d = new Date(value);
    if(compact){
        return d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear();
    }else{
        return months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
    }
}
window.formatDate = formatDate;

export let setCleanFilter = function(type, value){
    // todo: we probably want to keep year and project status filters unchanged
    let newFilter = {};
    let year = state.get('filter.year');
    if(year){
        newFilter['year'] = year;
    }
    // resetting the filter value in two steps so that the
    // hierarchy check in the filter model work correctly
    state.set('filter', newFilter); // first reset old values
    // then add new value.
    state.set('filter.'+type, value);
}

export let scrollY = function(){
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");

    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
}

export let scrollX = function(){
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");

    return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
}

export let scrollTo = function(element, duration=500, toTopOfPage=false){
    let box = element.getBoundingClientRect();

    let top = box.top;
    let bottom = box.bottom;
    let st = scrollY();

    let offset = 0;
    if(toTopOfPage){
        offset = top;
    }else if(top < 0){
        offset = top;
    }else if(bottom > window.innerHeight){
        offset = Math.min(top, bottom-window.innerHeight);
    }
    
    let callback = function(fact, start, offset, x){
        window.scrollTo(x, start + Math.round(fact*offset));
    }

    let c = new LifeCycle([window, callback, st, offset, scrollX()], duration, 'cubic');
    return c;
}